// extracted by css-extract-rspack-plugin
var _1 = "wdtnsU_Uep8E_K52";
var _2 = "kY45GfeMMzoMYyUM";
var _3 = "dO8xqizUfrkQn6u_";
var _4 = "P3EWc2k89okzc2dk";
var _5 = "R6c9F9ZFMg4gc3NO";
var _6 = "yNPxBet8WVExUNNM";
export { _1 as "arrow", _2 as "arrowLeft", _3 as "arrowRight", _4 as "sliderHeader", _5 as "sliderHolder", _6 as "sliderWrapper" }
// extracted by css-extract-rspack-plugin
var _1 = "wdtnsU_Uep8E_K52";
var _2 = "kY45GfeMMzoMYyUM";
var _3 = "dO8xqizUfrkQn6u_";
var _4 = "P3EWc2k89okzc2dk";
var _5 = "R6c9F9ZFMg4gc3NO";
var _6 = "yNPxBet8WVExUNNM";
export { _1 as "arrow", _2 as "arrowLeft", _3 as "arrowRight", _4 as "sliderHeader", _5 as "sliderHolder", _6 as "sliderWrapper" }
